import { useState, useContext } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  VStack,
  Text,
  Button,
  useToast,
  Icon,
} from '@chakra-ui/react';
import { CustomSmsMultiIcon } from '../../theme/multicolor-icons/CustomSmsMultiIcon';
import { HttpContext } from '../../context/HttpContext';
import CustomToast from '../../common/CustomToast';

const SendNowModal = ({
  isOpen,
  onClose,
  messageBatchId,
  messageBatchName,
  scheduledTime,
  fetchData,
  pageIndex,
  pageSize,
}) => {
  const { authAxios } = useContext(HttpContext);
  const toast = useToast();
  const [isSending, setIsSending] = useState(false);

  const sendNow = async () => {
    setIsSending(true);
    try {
      await authAxios.post(`/api/v1/batches/${messageBatchId}/send-now`);
      toast({
        render: ({ onClose: toastClose }) => (
          <CustomToast
            status="success"
            title="Batch queued to send now"
            description={`The previous schedule at ${scheduledTime} is canceled. Track progress on the Message History page.`}
            onClose={toastClose}
          />
        ),
      });
      fetchData({ pageIndex, pageSize });
    } catch (err) {
      toast({
        render: ({ onClose: toastClose }) => (
          <CustomToast
            status="error"
            title="Something went wrong"
            description="Please try again later."
            onClose={toastClose}
          />
        ),
      });
    } finally {
      setIsSending(false);
      onClose();
    }
  };

  const handleSendNowClick = () => {
    sendNow();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody p={10}>
          <VStack spacing={4} py={4} textAlign="center">
            <Icon as={CustomSmsMultiIcon} w={10} h={10} />
            <Text fontSize="xl" fontWeight="semibold">
              Override schedule and send now?
            </Text>
            <Text fontSize="md">
              This will send{' '}
              <Text as="span" fontWeight="bold">
                {messageBatchName}
              </Text>{' '}
              immediately and cancel the scheduled send at{' '}
              <Text as="span" fontWeight="bold">
                {scheduledTime}
              </Text>
              . Continue?
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter justifyContent="flex-end" gap={4}>
          <Button variant="secondary" onClick={onClose} size="sm">
            Keep Scheduled
          </Button>
          <Button onClick={handleSendNowClick} size="sm" isLoading={isSending}>
            Send Now
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SendNowModal;
